import { FunctionalComponent, h } from "@stencil/core";
import { DATE_ISO } from "./constants";
import { Dayjs } from "dayjs";

interface CalendarDayProps {
    baseClass: string;
    date: Dayjs;
    isDisabled?: boolean;
    isInactive?: boolean;
    isHighlighted?: boolean;
    isSelected?: boolean;
    isToday?: boolean;
    onSelectDay?: (date: Dayjs) => void;
    onHoverDay?: (date: Dayjs) => void;
}

const CalendarDay: FunctionalComponent<CalendarDayProps> = ({
    baseClass,
    date,
    isDisabled,
    isInactive,
    isHighlighted,
    isSelected,
    isToday,
    onSelectDay,
    onHoverDay
}) => {
    const handleClickButton = isDisabled || onSelectDay === undefined ? undefined : () => onSelectDay(date);
    const handleHoverButton = isDisabled || onHoverDay === undefined ? undefined : () => onHoverDay(date);
    const className = `${baseClass}__calendar-day`;
    return (
        <span
            class={{
                [className]: true,
                [`${className}--disabled`]: isDisabled,
                [`${className}--highlighted`]: isHighlighted,
                [`${className}--inactive`]: isInactive,
                [`${className}--selected`]: isSelected,
                [`${className}--today`]: isToday
            }}
        >
            <button
                aria-selected={!!isSelected}
                class={`${className}-btn`}
                data-day={date.format(DATE_ISO)}
                onClick={handleClickButton}
                onMouseEnter={handleHoverButton}
                type="button"
            >
                {date.format("D")}
            </button>
        </span>
    );
};

export default CalendarDay;
